export default {"src":"/_next/static/media/vi.b6249488.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};